import { Role } from './role';

export const ROLES: string[] = [
    "admin",
    "counsellor",
    "editor",
    "bruges_viewer"
];